export default __webpack_public_path__ + "static/media/hht1_ep15_minisitcom_04.453f17c7.png";